import { styled } from '$utils/theme'
import { rem } from 'polished'
import { Text, Block } from '$views/components'
import { Icon } from '$views/components/Icon'

interface Props {
  colums?: number
  index?: number
  fitContent?: boolean
}

export const WrapperCaretakerCard = styled.div<Props>`
  z-index: 3;
  position: absolute;
  bottom: 0;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  left: 0;
  right: 0;
  ${p =>
    p.theme.media.desktop &&
    p.fitContent &&
    `
    width: fit-content;
    margin: auto
  `};
  ${p =>
    p.theme.media.desktop`
    display:flex;
  `};
`

export const ContainerCaretakerCard = styled.div<Props>`
  display: grid;
  grid-template-columns: repeat(${p => p.colums}, 100%);
  ${p =>
    p.theme.media.desktop`
    grid-template-columns: repeat(${p.colums}, 600px);
  `}
  ${p =>
    p.colums > 1 &&
    `
    grid-template-columns: repeat(${p.colums}, 80%);

  `}
    ${p =>
      p.colums > 1 &&
      p.theme.media.desktop`
    grid-template-columns: repeat(${p.colums}, 400px);
  `}
  column-gap: ${p => rem(p.theme.sizes.mini)};
  margin: auto;
  padding: 0 0 ${p => rem(p.theme.sizes.medium)};
`

export const CaretakerCardWrapper = styled.div<Props>`
  &:hover {
    cursor: pointer;
  }
  ${p =>
    p.index === 0 &&
    `
    padding-left: ${rem(p.theme.sizes.mini)};
  `}
  ${p =>
    p.index === p.colums - 1 &&
    `
    padding-right: ${rem(p.theme.sizes.mini)};
  `}
  ${p =>
    p.colums === 1 &&
    p.theme.media.desktop`
    padding: 0 ${rem(p.theme.sizes.mini)};
  `}
`

export const CaretakerCardContainer = styled.div`
  background-color: ${p => p.theme.colors.white};
  border-radius: 25px;
  box-shadow: 0px 10px 15px -5px ${p => p.theme.colors.menu};
  padding: ${p => rem(p.theme.sizes.mini)} ${p => rem(p.theme.sizes.mini)} ${p => rem(p.theme.sizes.base)}
    ${p => rem(p.theme.sizes.mini)};
  height: 148px;
`

export const StyledRightAndTopBlock = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`

export const StyledOverflowText = styled(Text)<{ maxWidth?: number }>`
  max-width: ${p => p.maxWidth}px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const ContainerRightArrow = styled(Block)`
  z-index: 4;
  position: absolute;
  bottom: ${p => rem(p.theme.sizes.huge)};
  right: ${p => rem(p.theme.sizes.small)};
`

export const ContainerLeftArrow = styled(Block)`
  z-index: 4;
  position: absolute;
  bottom: ${p => rem(p.theme.sizes.huge)};
  left: ${p => rem(p.theme.sizes.small)};
`

export const ClickableAreaLeftArrow = styled.div`
  height: 24px;
  width: 24px;
  &:hover {
    cursor: pointer;
  }
  border-radius: 25px;
  background-color: ${p => p.theme.colors.white};
  box-shadow: 0 ${p => rem(p.theme.sizes.tiny)} ${p => rem(p.theme.sizes.base)} ${p => p.theme.colors.grey};
`

export const ClickableAreaRightArrow = styled.div`
  height: 24px;
  width: 24px;
  &:hover {
    cursor: pointer;
  }
  border-radius: 25px;
  background-color: ${p => p.theme.colors.white};
  box-shadow: 0 ${p => rem(p.theme.sizes.tiny)} ${p => rem(p.theme.sizes.base)} ${p => p.theme.colors.grey};
`

export const LeftArrowIcon = styled(Icon)`
  position: absolute;
  top: 1px;
  left: 6px;
`

export const RightArrowIcon = styled(Icon)`
  position: absolute;
  top: 1px;
  left: 7px;
`

export const PointerHoverBlock = styled.div`
  &:hover {
    cursor: pointer;
  }
  display: flex;
`



// WEBPACK FOOTER //
// ./src/views/FullMapCaretakers/components/CaretakerCard/CaretakerCard.style.ts